module.exports = __webpack_public_path__ + "img/visa-mobile-info_x2.3fa4a0e1.png";